@if (_document) {
  <div>
    <document-lines-editor
      #lineGrid
      [title]="'Doc::Composition' | abpLocalization"
      [columnDefs]="columnDefs"
      [rows]="_document.lines"
      [getContextMenuItems]="getContextMenuItems"
      [onCellFocused]="onCellFocused"
      [onRowSelected]="onRowSelected"
      [onCellValueChanged]="onCellValueChanged"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [textLineRole]="textLineRole"
      [chapterLineRole]="chapterLineRole"
      [readonly]="_readonly"
      [canAddLines]="true"
      [isBusyAdding]="isBusyAdding"
      [addActionBtns]="addActionBtns"
      [deleteActionEnabled]="deleteActionEnabled"
      [selectedLines]="selectedLines()"
      (deleteLines)="deleteLines()"
      [canExportLines]="true"
      [canCopyToClipboardLines]="true"
      [autoSize]="true"
      [thirdPartyDoc]="_document"
      (onModelUpdated)="onModelUpdated($event)"
    ></document-lines-editor>
  </div>
}
